import throttle from 'lodash.throttle'
import * as React from 'react'

interface Props {
  throttleWaitInMs?: number
}

export function useWindowSize({ throttleWaitInMs = 300 }: Props = {}) {
  const [size, setSize] = React.useState({
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
  })

  React.useEffect(() => {
    const handleResize = throttle(() => {
      setSize({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      })
    }, throttleWaitInMs)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [throttleWaitInMs])

  return size
}
